import { Typography } from '@mui/material';
import { FC, memo } from 'react';
import logo from 'assets/IllustrationIcons/logo.svg';

import { Box } from 'ui/Box';
import { Button } from './Button';

export interface RegisterMainScreenProps {
  navigateToStepsView: () => void;
}

export const RegisterMainScreen: FC<RegisterMainScreenProps> = memo(
  ({ navigateToStepsView }) => {
    return (
      <Box className="flex flex-1 flex-col items-center justify-center">
        <Box className="flex items-center gap-1">
          <Box
            component="img"
            src={logo}
            alt="Logo"
            className="h-12 w-12 md:h-24 md:w-24"
          />
          <Typography
            variant="h1Roboto"
            className="text-[32px] font-semibold leading-none text-black md:text-[62px]"
          >
            Hyperlink
          </Typography>
        </Box>
        <Typography
          variant="pSemiBold"
          className="sm mt-8 max-w-[27rem] text-center text-3xl text-black"
        >
          Hello. Welcome to the team. Nice to meet you
        </Typography>
        <Button
          className="mt-9 sm:max-w-28"
          onClick={navigateToStepsView}
          variant="next"
        />
      </Box>
    );
  }
);
